<template>
  <div class="container container-table login-page">
    <div class="row vertical-10p">
      <template v-for="alert in alerts">
        <b-alert :show="alert.dismiss" dismissible :variant="alert.type" @dismissed="alert.action">
          <h4>
            <i v-if="alert.type === 'success' || alert.type === 'warning'" class="icon fa fa-check"></i>
            <i class="icon fa fa-ban" v-else></i>
            {{`alert_${alert.type}` | translate}}!</h4>
          <p v-if="alert.type !== 'danger'">
            {{alert.message}}
          </p>
          <ul v-else>
            <li v-for="e in alert.message">
              {{e}}
            </li>
          </ul>
        </b-alert>
      </template>
        <div class="container">
          <div class="login-box box">
            <div class="login-logo">
              <router-link to="/">
                <img class="img-responsive center-block" src="/static/img/logo/logo-lg.svg">
              </router-link>
            </div>
            <div v-if="forgotten" class="login-box-body">
              <p class="login-box-msg">
                {{'forget_password_msg' | translate}}
              </p>
                <div class="form-group has-feedback">
                  <input :disabled="disabled" type="text" class="form-control" placeholder="Username" v-model="username">
                  <span class="fa fa-at form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                  <input v-validate="'required|email'" data-vv-as="'email'" class="form-control" name="email" placeholder="Email" type="text" v-model="forgetEmail">
                  <span class="fa fa-envelope form-control-feedback"></span>
                  <span v-show="errors.has('email')" class="small text-danger">{{ errors.first('email') }}</span>
                </div>
                <div class="row">
                  <div class=" col-xs-12 pull-right">
                    <b-btn class="btn btn-info btn-block" :disabled="errors.any()" @click="requestPass">
                      <i class="fa fa-sign-in mr-5"></i>{{'send' | translate}}
                    </b-btn>
                  </div>
                </div>
            </div>
            <div v-else class="login-box-body">
              <p class="login-box-msg">
                {{'sign_in_to_start_session' | translate}}
              </p>
              <form @submit.prevent="submit">
                <div class="form-group has-feedback">
                  <input :disabled="disabled" type="text" class="form-control" placeholder="Username" v-model="username">
                  <span class="fa fa-at form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                  <input :disabled="disabled" type="password" class="form-control" placeholder="Password" v-model="password">
                  <span class="fa fa-lock form-control-feedback"></span>
                </div>
                <div class="row">
                  <div class="col-sm-8 col-xs-12 hidden">
                    <div class="checkbox">
                      <label for="remember">
                        <input id="remember" v-model="remember" type="checkbox">Remember me
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-4 pull-right col-xs-12">
                    <button :disabled="disabled" class="btn btn-success btn-block" style="width: 100%">
                      <i class="fa fa-check-circle-o mr-5"></i> {{'sign_in' | translate}}
                    </button>
                  </div>
                </div>
              </form>
              <div class="text-center">
                <hr>
                <a @click="forgotten = true" class="btn btn-sm text-muted">{{'password_forgotten' | translate}}<i class="fa fa-question-circle ml-5"></i></a>
              </div>
            </div>
            <div class="overlay" v-show="loading">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Api from '@/services/Api'
import axios from 'axios'
import TestShell from "./TestShell";
import store from "../store";
export default {
  name: 'Login',
  data () {
    return {
      section: 'Login',
      loading: false,
      remember: false,
      username: '',
      password: '',
      response: '',
      forgetEmail: '',
      language: 'de',
      alerts: [],
      disabled: false,
      forgotten: false,
      translate (word) {
        let trans = this.$options.filters.translate(word, this.language)
        if (trans === 'undefined') {
          return false
        } else {
          return trans
        }
      }
    }
  },
  methods: {
    redirect () {
      this.forgotten = false
    },
    requestPass () {
      this.$validator.validate()
        .then(result => {
          if(result) {
            API.put('/accounting/user/password-request', {username: this.username, email: this.forgetEmail})
              .then(result => {
                let alert = {type: 'success', dismiss: 4, message: this.translate('pword_alert_msg'), action: this.redirect}
                this.alerts.push(alert)
              })
              .catch(error => {
                let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message], action: this.handleError}
                this.alerts.push(alert)
              })
          }
        })
    },
    handleError () {
      console.log('')
    },
    submit () {
      this.loading = true
      Api().post('/login', {username: this.username, password: this.password})
        .then(response => {
          this.$store.commit('updatePermissions', response.data.permissions)
          this.$store.commit('updateToken', JSON.parse(JSON.stringify(response.data.token)))
          this.$store.commit('updateLoggedInStatus', true)
          axios.all([Api().get(`/accounting/user?id=${response.data.id}`), Api().get(`/company`), Api().get('/frontend/navigation/page/tree')])
          .then(axios.spread((...responses) => {
            this.$store.commit('updateUser', responses[0].data)
            this.$store.commit('updateUserAdmin', response.data.admin)
            this.$store.commit('updateRoles', responses[0].data.roles)
            this.$store.commit('updateCompanies', responses[1].data)
            this.$store.commit('updateNavTree', responses[2].data)
            let { routes } = this.$router.options
            let routeData = routes.find(r => r.path === '/home')
            this.recursiveRouteCreator(responses[2].data[0].children, routeData.children, '')
            this.$store.commit('updateRouteData', routeData)
            this.loading = false
            let activePage = routeData.children.filter(r => r.path.substr(0,6) !== '/admin' && r.path !== '/*')[0]
            this.$store.commit('updateActivePage', activePage.id)
            this.$router.push(activePage.path)
          }))
        })
        .catch(error => {
          this.loading = false
          let message = []
          Object.keys(error.response.data.errors).forEach(x => {
            message.push(error.response.data.errors[x][0])
          })
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: message
          });
        })
    },
    recursiveRouteCreator (nav, target, parentName) {
      nav.forEach(n => {
        if (n.children.length > 0) {
          this.recursiveRouteCreator(n.children, target, this.getName(parentName, n.name.toLowerCase().split(' ').join('-')))
        } else {
          let routeData = {
            path: `/${this.getName(parentName, n.name.toLowerCase().split(' ').join('-'))}`,
            name: n.name.toLowerCase().split(' ').join('-'),
            component: TestShell,
            id: n.id
          }
          if (!target.find(r => r.path === routeData.path)) {
            target.push(routeData)
          }
        }
      })
    },
    getName (parentName, n) {
      return parentName !== '' ? `${parentName}/${n}` : `${n}`
    }
  },
  mounted () {
    if (window.localStorage.getItem('IE')) {
      this.disabled = true
      this.$notify({
        group: 'foo',
        type: 'error',
        title: 'Error',
        text: 'Bitte beachten Sie, dass die Anmeldung im neuen Supplier ratings site über den Internet Explorer nicht möglich ist. Bitte melden Sie sich hierzu über Google Chrome oder Morzilla Firefox an. Vielen Dank.'
      });
    }
    if (this.$store.state.loggedInStatus) {
      this.$router.push(this.$store.state.routeData.children.filter(r => r.path.substr(0,6) !== '/admin')[0].path)
    }
  }
}
</script>
<style scoped>
  .loading-gif {
    top: 43%;
    left: 39%;
    width: 23%;
    position: absolute;
  }
  .login-page {
    height: 100vh;
    width: 100%;
  }
</style>
